export default __webpack_public_path__ + "7c71586e909365b0628e45108b0c0c79.png";